import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../contexts/AuthContext';

function ForgotPassword() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1 = 输入邮箱, 2 = 输入验证码
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [setPasswordEnabled, setSetPasswordEnabled] = useState(true);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const tick = () => {
    let n = 60;
    setCooldown(n);
    const t = setInterval(() => {
      n -= 1;
      setCooldown(n);
      if (n <= 0) clearInterval(t);
    }, 1000);
  };

  const handleSendCode = async (e) => {
    e?.preventDefault?.();
    setError(''); setInfo('');
    if (!email) { setError('请输入邮箱'); return; }
    setLoading(true);
    try {
      const res = await api.post('/auth/email-code/send', { email });
      setInfo(res.data.message || '验证码已发送，请查收邮箱');
      setStep(2);
      tick();
    } catch (err) {
      setError(err.response?.data?.error || '发送失败，请稍后重试');
    }
    setLoading(false);
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError(''); setInfo('');
    if (!code) { setError('请输入验证码'); return; }
    setLoading(true);
    try {
      const res = await api.post('/auth/email-code/verify', { email, code });
      const { token, user } = res.data;
      loginWithToken(token, user);

      // 如果用户填了新密码就顺便重置
      if (setPasswordEnabled && newPassword && newPassword.length >= 6) {
        try {
          await api.post('/auth/password/reset', { newPassword });
        } catch (_) { /* ignore */ }
      }
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || '验证失败');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>邮箱验证码登录 / 找回密码</h2>
        <p className="auth-subtitle">输入注册邮箱，我们会发送验证码，验证后可直接登录并重置密码</p>

        {error && <div className="error-message">{error}</div>}
        {info && <div className="error-message" style={{ background: '#ecfdf5', color: '#059669' }}>{info}</div>}

        {step === 1 && (
          <form onSubmit={handleSendCode}>
            <div className="form-group">
              <label className="form-label">邮箱</label>
              <input className="form-input" type="email" value={email}
                onChange={e => setEmail(e.target.value)} placeholder="your@email.com" required />
            </div>
            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
              {loading ? '发送中...' : '发送验证码'}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleVerify}>
            <div className="form-group">
              <label className="form-label">邮箱</label>
              <input className="form-input" type="email" value={email} disabled />
            </div>
            <div className="form-group">
              <label className="form-label">6 位验证码</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <input className="form-input" value={code} onChange={e => setCode(e.target.value)}
                  placeholder="123456" maxLength={6} inputMode="numeric" required style={{ flex: 1 }} />
                <button type="button" className="btn btn-secondary"
                  onClick={handleSendCode} disabled={cooldown > 0 || loading}>
                  {cooldown > 0 ? `${cooldown}s` : '重新发送'}
                </button>
              </div>
            </div>

            <div className="form-group">
              <label className="toggle-group" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input type="checkbox" checked={setPasswordEnabled}
                  onChange={e => setSetPasswordEnabled(e.target.checked)} />
                <span style={{ fontSize: '0.9rem' }}>顺便设置新密码（可选）</span>
              </label>
            </div>

            {setPasswordEnabled && (
              <div className="form-group">
                <label className="form-label">新密码（至少 6 位，留空则不改）</label>
                <input className="form-input" type="password" value={newPassword}
                  onChange={e => setNewPassword(e.target.value)} placeholder="至少 6 位" minLength={6} />
              </div>
            )}

            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
              {loading ? '验证中...' : '验证并登录'}
            </button>
            <button type="button" className="btn btn-ghost" style={{ width: '100%', marginTop: 8 }}
              onClick={() => { setStep(1); setCode(''); setError(''); setInfo(''); }}>
              修改邮箱
            </button>
          </form>
        )}

        <p className="auth-footer">
          想起密码了？<Link to="/login">返回登录</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
